import React, { useState } from 'react'
import { Tag } from 'lucide-react'

/**
 * QA Stripe-min promo code entry (hidden unless VITE_ENABLE_STRIPE_MIN_QA_PROMO_UI=true).
 */
const PromoCodeApply = ({
  checkoutType = 'hotel',
  onApplied,
  onCleared,
  disabled = false
}) => {
  const [input, setInput] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleApply = async () => {
    setError('')
    const code = String(input || '').trim()
    if (!code) {
      setError('Enter a promo code')
      return
    }
    setLoading(true)
    try {
      await onApplied(code)
    } catch (e) {
      setError(e?.message || 'Could not apply promo code')
    } finally {
      setLoading(false)
    }
  }

  const handleClear = () => {
    setInput('')
    setError('')
    onCleared?.()
  }

  return (
    <div className="min-w-0 rounded-xl border border-amber-200 bg-amber-50/80 p-4 space-y-3">
      <div className="flex items-center gap-2 text-amber-900">
        <Tag className="h-4 w-4 shrink-0" />
        <span className="text-sm font-semibold">QA promo (Stripe minimum charge)</span>
      </div>
      <p className="text-xs text-amber-800/90">
        Staging only. Each paid line charges only the Stripe minimum for that currency (e.g. $0.50 USD). Requires backend{' '}
        <code className="text-[11px] bg-white/60 px-1 rounded">ENABLE_STRIPE_MIN_QA_PROMO</code> and allowlisted code.
      </p>
      <div className="flex flex-col gap-2 min-w-0">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Promo code"
          disabled={disabled || loading}
          className="w-full min-w-0 rounded-lg border border-amber-200 bg-white px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400"
          autoComplete="off"
        />
        <div className="flex gap-2 min-w-0">
          <button
            type="button"
            onClick={handleApply}
            disabled={disabled || loading}
            className="flex-1 min-w-0 rounded-lg bg-amber-600 px-4 py-2 text-sm font-semibold text-white hover:bg-amber-700 disabled:opacity-50"
          >
            {loading ? '…' : 'Apply'}
          </button>
          <button
            type="button"
            onClick={handleClear}
            disabled={disabled || loading}
            className="flex-1 min-w-0 rounded-lg border border-amber-300 bg-white px-3 py-2 text-sm text-amber-900 hover:bg-amber-100"
          >
            Remove
          </button>
        </div>
      </div>
      {error ? <p className="text-xs text-red-600">{error}</p> : null}
    </div>
  )
}

export default PromoCodeApply
